import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

/**
 * Skeleton loading component for post purchase rule edit page
 */
export const PostPurchaseRuleEditSkeleton = () => (
	<div className="bg-background min-h-screen">
		<div className="flex flex-col space-y-4 sm:space-y-6">
			{/* Header Skeleton */}
			<div className="mb-4 flex items-center justify-between">
				<div className="flex items-center gap-2">
					<Skeleton className="h-10 w-10" />
					<div className="space-y-2">
						<Skeleton className="h-8 w-64" />
						<Skeleton className="h-4 w-96" />
					</div>
				</div>
				<div className="flex gap-2">
					<Skeleton className="h-10 w-24" />
					<Skeleton className="h-10 w-32" />
				</div>
			</div>

			{/* Rule Matching Card */}
			<Card>
				<CardHeader>
					<Skeleton className="h-6 w-32" />
					<Skeleton className="h-4 w-64" />
				</CardHeader>
				<CardContent>
					<div className="flex gap-4">
						<Skeleton className="h-5 w-5" />
						<Skeleton className="h-4 w-48" />
						<Skeleton className="h-5 w-5" />
						<Skeleton className="h-4 w-48" />
					</div>
				</CardContent>
			</Card>

			{/* Priority Card */}
			<Card>
				<CardHeader>
					<Skeleton className="h-6 w-24" />
					<Skeleton className="h-4 w-80" />
				</CardHeader>
				<CardContent>
					<div className="space-y-2">
						<Skeleton className="h-4 w-32" />
						<Skeleton className="h-10 w-full" />
					</div>
				</CardContent>
			</Card>

			{/* Conditions Card */}
			<Card>
				<CardHeader>
					<Skeleton className="h-6 w-32" />
					<Skeleton className="h-4 w-64" />
				</CardHeader>
				<CardContent className="space-y-4">
					{/* Info section */}
					<div className="space-y-2 rounded-md bg-muted p-3">
						{[...Array(3)].map((_, i) => (
							<div key={i} className="flex gap-2">
								<Skeleton className="h-3 w-3" />
								<div className="space-y-1">
									<Skeleton className="h-3 w-32" />
									<Skeleton className="h-3 w-48" />
								</div>
							</div>
						))}
					</div>

					{/* Condition line */}
					<div className="relative rounded-lg border p-4">
						<div className="space-y-4">
							<Skeleton className="h-10 w-full" />
							<div className="grid grid-cols-2 gap-4">
								<Skeleton className="h-10 w-full" />
								<Skeleton className="h-10 w-full" />
							</div>
						</div>
						<Skeleton className="absolute -right-2 -top-2 h-6 w-6 rounded-full" />
					</div>

					<Skeleton className="h-10 w-40" />
				</CardContent>
			</Card>

			{/* Offers Card */}
			<Card>
				<CardHeader>
					<Skeleton className="h-6 w-24" />
					<Skeleton className="h-4 w-64" />
				</CardHeader>
				<CardContent>
					<Skeleton className="h-10 w-full" />
				</CardContent>
			</Card>
		</div>
	</div>
)

